/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ChallengeCategoryWithChallengeDto } from './challenge-category-with-challenge-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { DeliveryDto } from './delivery-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { ParticipationEntitlementDto } from './participation-entitlement-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface GetParticipationResponseDto
 */
export interface GetParticipationResponseDto {
    /**
     * Participation ID
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'id': string;
    /**
     * Challenge category ID
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'challengeCategoryId': string;
    /**
     * User ID
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'userId': string;
    /**
     * Delivery address ID for finisher items (optional for digital-only challenges)
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'deliveryAddressId'?: string;
    /**
     * Total distance covered by the user in this challenge category in meters
     * @type {number}
     * @memberof GetParticipationResponseDto
     */
    'totalDistanceCovered': number;
    /**
     * Finisher shirt size selected by the user
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'finisherShirtSize': string;
    /**
     * Participation status
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'status': GetParticipationResponseDtoStatusEnum;
    /**
     * Payment status
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'paymentStatus': GetParticipationResponseDtoPaymentStatusEnum;
    /**
     * Payment amount in the local currency
     * @type {number}
     * @memberof GetParticipationResponseDto
     */
    'paymentAmount': number;
    /**
     * Price type for this participation
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'priceType': GetParticipationResponseDtoPriceTypeEnum;
    /**
     * Electronic bib number assigned to the participant
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'eBibNumber'?: string;
    /**
     * URL of the electronic bib number image
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'eBibNumberImageUrl'?: string;
    /**
     * URL of the electronic certificate image
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'eCertificateImageUrl'?: string;
    /**
     * Whether participant chose to include finisher shirt
     * @type {boolean}
     * @memberof GetParticipationResponseDto
     */
    'shouldIncludeFinisherShirt': boolean;
    /**
     * Whether participant chose to include medal
     * @type {boolean}
     * @memberof GetParticipationResponseDto
     */
    'shouldIncludeMedal': boolean;
    /**
     * Payment amount for finisher shirt when optional
     * @type {number}
     * @memberof GetParticipationResponseDto
     */
    'finisherShirtPaymentAmount': number;
    /**
     * Payment amount for medal when optional
     * @type {number}
     * @memberof GetParticipationResponseDto
     */
    'medalPaymentAmount': number;
    /**
     * Payment processing fee amount
     * @type {number}
     * @memberof GetParticipationResponseDto
     */
    'paymentProcessingFeeAmount': number;
    /**
     * Delivery fee amount
     * @type {number}
     * @memberof GetParticipationResponseDto
     */
    'deliveryFeeAmount': number;
    /**
     * Custom entitlements selected for this participation
     * @type {Array<ParticipationEntitlementDto>}
     * @memberof GetParticipationResponseDto
     */
    'participationEntitlements'?: Array<ParticipationEntitlementDto>;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'updatedAt': string;
    /**
     * Challenge category details
     * @type {ChallengeCategoryWithChallengeDto}
     * @memberof GetParticipationResponseDto
     */
    'challengeCategory': ChallengeCategoryWithChallengeDto;
    /**
     * Challenge status
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'challengeStatus': GetParticipationResponseDtoChallengeStatusEnum;
    /**
     * Progress percentage
     * @type {number}
     * @memberof GetParticipationResponseDto
     */
    'progressPercentage': number;
    /**
     * Delivery details for this participation
     * @type {DeliveryDto}
     * @memberof GetParticipationResponseDto
     */
    'delivery'?: DeliveryDto;
    /**
     * Payment URL
     * @type {string}
     * @memberof GetParticipationResponseDto
     */
    'paymentUrl': string;
    /**
     * User details
     * @type {UserDto}
     * @memberof GetParticipationResponseDto
     */
    'user'?: UserDto;
}

export const GetParticipationResponseDtoStatusEnum = {
    Ongoing: 'ongoing',
    Completed: 'completed',
    Cancelled: 'cancelled'
} as const;

export type GetParticipationResponseDtoStatusEnum = typeof GetParticipationResponseDtoStatusEnum[keyof typeof GetParticipationResponseDtoStatusEnum];
export const GetParticipationResponseDtoPaymentStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Expired: 'expired'
} as const;

export type GetParticipationResponseDtoPaymentStatusEnum = typeof GetParticipationResponseDtoPaymentStatusEnum[keyof typeof GetParticipationResponseDtoPaymentStatusEnum];
export const GetParticipationResponseDtoPriceTypeEnum = {
    Regular: 'regular',
    EarlyBird: 'early_bird',
    Free: 'free'
} as const;

export type GetParticipationResponseDtoPriceTypeEnum = typeof GetParticipationResponseDtoPriceTypeEnum[keyof typeof GetParticipationResponseDtoPriceTypeEnum];
export const GetParticipationResponseDtoChallengeStatusEnum = {
    NotStarted: 'not_started',
    Ongoing: 'ongoing',
    Ended: 'ended',
    Cancelled: 'cancelled'
} as const;

export type GetParticipationResponseDtoChallengeStatusEnum = typeof GetParticipationResponseDtoChallengeStatusEnum[keyof typeof GetParticipationResponseDtoChallengeStatusEnum];


